import React from 'react';
import CommonLayout from "./CommonLayout";
import ReceiptPopover from '../../components/ReceiptPopover';
import { Fragment, useState, useEffect } from 'react';
import axios from "axios";
import { API_URL } from 'api/config';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import Tooltip from "@mui/material/Tooltip";
import { Dialog, Transition, Popover } from "@headlessui/react";

const ReceiptRequests = () => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [selectedReceipt, setSelectedReceipt] = useState<any>(null);
    const [requests, setRequests] = useState([]);
    const token = localStorage.getItem('token');    
    const [ isPdfGenerated, setIsPdfGenerated] = useState(false);
    const [receiptId, setReceiptId] = useState(null);
    const [deletePopoverOpen, setDeletePopoverOpen] = useState(false);

    const getReceiptRequests = async () => {
      try {
        const response = await axios.get(`${API_URL}/receipt/requests`, {
          headers: {
            token: token,
          },
        });
        if (response.data.error === true) {
          toast.error(`${response.data.message}`);
        } else if (response.data.error === false) {
          // toast.success(response.data.message);
          setRequests(response.data.requests);
        }
      } catch (error) {
        console.log("Error fetching receipt requests", error);
      }
    };
 
    useEffect(() => {
      const storedValue = localStorage.getItem("isPdfGenerated");
      if (storedValue === "true") {
        setIsPdfGenerated(true);
      }
      getReceiptRequests();
    }, []);

    const formatDateTime = (isoString: any) => {
      const date = new Date(isoString);
  
      return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    const confirmDeleteReceipt = async () => {
      setDeletePopoverOpen(false);
      try {
        const response = await axios.post(`${API_URL}/receipt/delete-receipt`,{receiptId}, {
          headers: {
            token: token,
          },
        });
        if (response.data.error === false) {
          toast.success(`${response.data.message}`);
          getReceiptRequests();
        }
      } catch (error) {
        toast.error("Failed to delete receipt request.");
      }
    };
  
  return (
    <div className="flex w-screen">
      <CommonLayout>
        {requests && requests.length > 0 ? (
          requests.map((req: any) => (
            <div
              key={req._id}
              className="lg:bg-neutral-50 lg:dark:bg-black/20 grid grid-cols-1 gap-6  rounded-3xl mb-3"
            >
              <div
                className="nc-FlightCardgroup p-4 sm:p-6 relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl hover:shadow-lg transition-shadow space-y-6"
                data-nc-id="FlightCard"
              >
                <div className="sm:pr-20 relative">
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-6 sm:space-y-0">
                    {/* date - time */}
                    <div className="lg:block min-w-[150px] flex-[4]">
                      <div className="font-medium text-lg">Date & Time</div>
                      <div className="text-sm text-neutral-500 font-normal mt-0.5">
                        {formatDateTime(req?.updatedAt)}
                      </div>
                    </div>

                    {/* property name */}
                    <div className="lg:block flex-[4] whitespace-nowrap">
                      <div className="font-medium text-lg">Property Name</div>
                      <div className="text-sm text-neutral-500 font-normal mt-0.5">
                      {
                        req?.status==="pending" ? req?.propertyId?.title : 
                        req?.propertyName
                      }
                      </div>
                    </div>

                    {/* guest name */}
                    <div className="lg:block flex-[4] whitespace-nowrap">
                      <div className="font-medium text-lg">Guest Name</div>
                      <div className="text-sm text-neutral-500 font-normal mt-0.5">
                        {
                          req?.status==="pending" ? req?.guestId.firstname + " " + req?.guestId.lastname : 
                          req?.guestName
                        }
                      </div>
                    </div>

                    {/* fullfill button */}
                    <div className="flex items-center flex-[4] justify-self-start whitespace-nowrap sm:text-left space-x-2">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedReceipt(req);
                          setIsPopoverOpen(true);
                        }}
                        className={`border rounded-3xl px-3 py-1 border-neutral-400 text-custom-color w-fit ${
                          req.status === "fulfilled"
                            ? "!bg-gray-300"
                            : "bg-custom-color text-white"
                        }`}
                      >
                        {(req?.status === "pending" && req?.reRequestCount) > 0
                          ? "Re-Fulfill Request"
                          : req?.status === "fulfilled"
                          ? "Fullfilled"
                          : "Fullfill Request"}
                      </button>

                      {/* download button */}
                      
                      {(req?.status === "fulfilled") && (
                        <Tooltip title="Download Receipt" placement="right-end">
                          <div
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                              if (!req?.pdfFilePath) {
                                toast.error("PDF URL not available.");
                                return;
                              }
                              window.open(req.pdfFilePath, "_blank");
                            }}
                            className="text-white rounded-3xl"
                          >
                            <span>
                            <ArrowDownTrayIcon className="text-custom-color w-6 font-bold" />
                            </span>
                          </div>
                        </Tooltip>
                      )}

                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setReceiptId(req._id);
                          setDeletePopoverOpen(true);
                        }}
                        className={`border rounded-3xl px-3 py-1 border-neutral-400 text-custom-color w-fit bg-custom-color text-white`}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center w-full py-12 text-neutral-500 text-lg">
            No receipt requests available.
          </div>
        )}

        {/* ✅ Only ONE ReceiptPopover rendered here */}
        {selectedReceipt && (
          <ReceiptPopover
            isPopoverOpen={isPopoverOpen}
            setIsPopoverOpen={setIsPopoverOpen}
            receiptId={selectedReceipt._id}
            maxGuests={selectedReceipt?.propertyId?.guests}
            setIsPdfGenerated={setIsPdfGenerated}
            getReceiptRequests={getReceiptRequests}
          />
        )}
           {/* DELETE ACCOUNT MODAL */}
             <Transition show={deletePopoverOpen} as={Fragment}>
                <Dialog
                  as="div"
                  className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
                  onClose={() => setDeletePopoverOpen(false)}
                >
                  <Dialog.Panel className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-lg w-full shadow-xl">
                    <Dialog.Title className="text-lg font-semibold text-center">
                      Confirm Receipt Request Deletion
                    </Dialog.Title>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2">
                      Are you sure you want to delete your receipt request? This action cannot
                      be undone.
                    </p>
                    <div className="mt-4 flex justify-center gap-4">
                      <button
                        onClick={() => setDeletePopoverOpen(false)}
                        className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded-md"
                      >
                        No, Cancel
                      </button>
                      <button
                        onClick={confirmDeleteReceipt}
                        className="px-4 py-2 bg-red-600 text-white rounded-md"
                      >
                        Yes, Delete Receipt
                      </button>
                    </div>
                  </Dialog.Panel>
                </Dialog>
              </Transition>
      </CommonLayout>
    </div>
  );
}


export default ReceiptRequests